module.exports = __webpack_public_path__ + "assets/img/homeback.dc12b5ba.png";